import {
  Button,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@apexinternal/ui-components'
import { Flex, Stack, Text } from '@chakra-ui/react'
import React from 'react'
import { AccountDetails } from '../../../../types'
import CloseAccountAlert from './CloseAccountAlert'
import CloseAccountDescription from './CloseAccountDescription'

export interface ConfirmModalContentProps {
  accountDetails: AccountDetails
  isReplacedByFdid: boolean
  fdid: string
  onClose: () => void
  onConfirm: () => void
  onBack: () => void
}

const ConfirmModalContent = ({
  accountDetails,
  isReplacedByFdid,
  fdid,
  onClose,
  onConfirm,
  onBack,
}: ConfirmModalContentProps) => {
  return (
    <ModalContent>
      <ModalHeader>Confirm Close Account</ModalHeader>
      <ModalCloseButton onClick={onClose} />
      <ModalBody>
        <Stack spacing="1rem">
          <CloseAccountDescription accountDetails={accountDetails} />
          <Text>Please confirm that you would like to close this account.</Text>
          {isReplacedByFdid && (
            <Stack spacing="1rem" data-testid="fdidReplacement">
              <Text>This account is being replaced.</Text>
              <Text fontWeight="semibold">Replaced by FDID</Text>
              <Text>{fdid}</Text>
            </Stack>
          )}
          <CloseAccountAlert />
        </Stack>
      </ModalBody>
      <ModalFooter>
        <Flex width="100%" justifyContent={'space-between'}>
          <Button variant="link" onClick={onBack}>
            &lt; Back
          </Button>
          <Stack direction="row" spacing={2}>
            <Button variant="white" onClick={onClose} tabIndex={1}>
              Cancel
            </Button>
            <Button variant="negative" onClick={onConfirm} tabIndex={2}>
              Close Account
            </Button>
          </Stack>
        </Flex>
      </ModalFooter>
    </ModalContent>
  )
}

export default ConfirmModalContent
